import type { PlayerProfile } from '@shared/auth/types';
import { getTopLevelDomain } from '@shared/utils';
import type { PlayerRegistrationData } from '../hooks/types';
import type { DataLayerPlayer } from './types';

/**
 * Builds the player object for data layer tracking
 * @param profile - Player profile data from the API
 * @param registrationData - Optional registration data for preferences (only used for playerPreferableProduct)
 * @returns Player object for data layer tracking
 */
function buildDataLayerPlayer(profile: PlayerProfile | null | undefined, registrationData?: PlayerRegistrationData): DataLayerPlayer {
  const playerPreferableProduct = (() => {
    const prefs = registrationData?.registrationContactPreferencesData?.notificationPreferences;

    if (!prefs) {
      return 'None';
    }

    const products: string[] = [];

    if (prefs.lottery) products.push('Lottery');
    if (prefs.casinoAndScratchcards) products.push('Casino');
    if (prefs.sportsbook) products.push('Sportsbook');

    return products.length ? products : 'None';
  })();

  return {
    playerNr: profile?.nr ? profile.nr.toString() : 'unknown',
    playerCurrency: 'GBP',
    playerLanguage: profile?.language || 'unknown',
    playerDomain: getTopLevelDomain(),
    playerSegment: 'prospect_strong',
    playerValueGroup: 'New Player',
    playerPreferableProduct,
    playerEmail: profile?.email || 'unknown',
    playerPostCode: profile?.postCode || 'unknown',
    playerCountry: profile?.country || 'unknown',
  };
}

export { buildDataLayerPlayer };
